import { jwtDecode } from 'jwt-decode';


let auth0LogoutFunction = null;

export const setAuth0Logout = (logoutFn) => {
  auth0LogoutFunction = logoutFn;
};

const handleAuthError = () => {
  localStorage.clear();
  sessionStorage.clear();
  
  if (auth0LogoutFunction) {
    auth0LogoutFunction({ 
      logoutParams: { 
        returnTo: window.location.origin 
      } 
    });
  } else {
    window.location.replace('/');
  }
};

const noAuthorizedInterceptor = () => ({
  onFulfilled: (response) => response,
  onRejected: (error) => {
    // Manejar errores 401
    if (error.response?.status === 401 ){
      const token = localStorage.getItem('@csi/token');
      if (!token) {
        handleAuthError();
        return Promise.reject(error);
      }
      try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;
        
        if (decoded.exp < now) {
          handleAuthError();
        }
      } catch (e) {
        handleAuthError();
      }
    }
    
    return Promise.reject(error);
  }
});

export default noAuthorizedInterceptor;